import {observer} from "mobx-react";
import MobileTitle from "../../components/MobileTitle";
import React, {useState} from "react";
import {NavBar, TabBar} from "antd-mobile";
import BottomSideDrawer from "../../components/BottomSideDrawer";
import Nav from "../../components/Nav";
import {Affix, Card} from "antd";
import {pp} from "../../utils";
import {ScheduleOutlined, TrophyOutlined} from "@ant-design/icons";
import _ from "lodash";
import Device from "../../components/Device";
import Leaderboard, {LeaderboardBtn} from "../tournament/Leaderboard";
import MatchScorecard from "./MatchScorecard";
import JuniorsTeamView from "./JuniorsTeamView";
import Tourney from "~/apps/tourney/Tourney.js";

export const MatchMV = observer(({m, name, teamById, total}) => {
  // Get court info - either single court or multiple courts
  const courtInfo = m.courts?.length === 1 ? `court ${m.courts[0]}` :
                     m.courts?.length > 1 ? `courts ${m.courts.join(',')}` :
                     m.court ? `court ${m.court}` : null;

  const matchName = m.name_view || m.name || name;

  const title = courtInfo ? (
    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
      <div>
        {matchName} <span style={{fontSize: '12px', color: '#666', fontWeight: 'normal'}}>(#{m.mid})</span>
      </div>
      <div style={{fontSize: '12px', color: '#666', fontWeight: 'normal'}}>{courtInfo}</div>
    </div>
  ) : (
    <div>
      {matchName} <span style={{fontSize: '12px', color: '#666', fontWeight: 'normal'}}>(#{m.mid})</span>
    </div>
  );

  return <div data-match-id={m.id}>
    <Card size="small" title={title}>
      <MatchScorecard m={m} teamById={teamById} total={total}/>
    </Card>
  </div>
});

export let RoundsManagerMV = observer(({rounds, teamById, total}) => {

  return <div className="rounds-mv space-y-2" style={{backgroundColor: "#f1f5f9"}}>
    {rounds.map((r, i) => <div key={i}>
      <div data-round-id={r.id} className="space-y-2">
        <MobileTitle title={r.name} />
        <div className="space-y-2">
          {r.matches.map((m, j) => <MatchMV total={total} key={m.id} m={m} name={m.name_view} teamById={teamById}/>)}
          {r.bye_ids && r.bye_ids.length > 0 && r.bye_ids.map(id => <Card key={id} size="small">
            <div className="h-space">
              <div>{teamById[id].name}</div>
              <div>BYE</div>
            </div>
          </Card>)}
        </div>
      </div>
    </div>)}
  </div>
});

export let Viewer = observer(({dp, teamById}) => {
  let asTeam4 = dp.full_name2?.match(/Teams/);
  let rounds = dp.trounds || dp.rounds;

  if (asTeam4)
    return <JuniorsTeamView rounds={rounds} teamById={teamById} />
  else
    return <RoundsManagerMV rounds={rounds} teamById={teamById} total2={asTeam4}/>
});

let PoolMV = observer(({dp, back, teamById}) => {
  let tabs = [
    {
      key: 'schedule',
      title: "Schedule",
      icon: <ScheduleOutlined />,
      content: <Viewer dp={dp} teamById={teamById} />,
    },
    {
      key: 'leaderboard',
      title: "Leaderboard",
      icon: <TrophyOutlined />,
      content: <Leaderboard division={dp} teamById={teamById}/>,
    },
  ];

  let changeTab = t => {
    window.scrollTo(0, 0);
    Nav.setTab(t, true);
  };

  let playoff = dp.kind === "playoff"

  let tab = Nav.tab || "schedule";

  return <div className="bg-white" style={{height: "100vh", position: 'absolute', top: 0, bottom: 0, width: "100%", zIndex: 10}}>
    <Affix offsetTop={0}>
      <NavBar onBack={back}>{dp.full_name2}</NavBar>
    </Affix>
    {_.find(tabs, { key: tab })?.content}
    <br/>
    <br/>
    <br/>
    <br/>
    { (!playoff || Tourney.stjude) && <div style={{position: 'fixed', bottom: 0, maxWidth: "1000px", width: "100%", backgroundColor: 'white', borderTop: "1px solid gray"}}>
      <TabBar defaultActiveKey={tab} value={tab} onChange={changeTab}>
        {tabs.map(item => (
          <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
        ))}
      </TabBar>
    </div> }
  </div>
});

let PlayerView = observer(({divisions}) => {
  let dp = Nav.division;

  return null;

  let teamById = _.keyBy(_.flatMap(divisions, d => d.play_teams || d.teams), 'id');

  let close = () => {
    Nav.setDivision(null)
  }

  if (Device.xs) {
    if (!dp)
      return;

    return <PoolMV dp={dp} back={close} teamById={teamById}/>
  }

  if (!dp)
    return <BottomSideDrawer visible={false} />;
  else {
    return <BottomSideDrawer visible={true} title={dp.name} onClose={close}>
      { dp.kind !== "playoff" && <div className="p-2"><LeaderboardBtn division={dp} teamById={teamById}/></div> }
      <Viewer dp={dp} teamById={teamById} />
    </BottomSideDrawer>
  }
})

export default PlayerView;